import { OSMRNRoyaltyData } from "../../../types/Royalties/OSMRNRoyaltyData";

export interface OSMRNRoyaltyDetailsProps {
  royaltyData: OSMRNRoyaltyData;
}

const OSMRNRoyaltyDetails = ({ royaltyData }: OSMRNRoyaltyDetailsProps) => {
  return (
    <>
      <dt>Number of User/Terminals</dt>
      <dd>{royaltyData.users}</dd>
      <dt>Number of High Density Tiles</dt>
      <dd>{royaltyData.highDensityTiles}</dd>
      <dt>Number of Medium Density Tiles</dt>
      <dd>{royaltyData.mediumDensityTiles}</dd>
      <dt>Number of Low Density Tiles</dt>
      <dd>{royaltyData.lowDensityTiles}</dd>
      <dt>Number of Zero Density Tiles</dt>
      <dd>{royaltyData.zeroDensityTiles}</dd>
      <dt>% of National Coverage</dt>
      <dd>{(royaltyData.percentageOfNationalCoverage * 100).toFixed(2)}%</dd>
    </>
  );
};

export default OSMRNRoyaltyDetails;
